import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("🔵 AiComparisonController - connect() called")
    console.log("🔵 AiComparisonController - element:", this.element)
  }

  async handleSubmit(event) {
    event.preventDefault()
    console.log("🟢 AiComparisonController - handleSubmit() called")
    
    const formData = new FormData(this.element)
    console.log("🟢 AiComparisonController - FormData created:", formData)
    
    const headers = {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      'Accept': 'text/javascript'
    }
    
    try {
      console.log("🟢 AiComparisonController - Sending request...")
      const response = await fetch('/en/admin/ai_comparison/compare', {
        method: 'POST',
        body: formData,
        headers: headers
      })
      
      console.log("🟢 AiComparisonController - Response received:", response)
      console.log("🟢 AiComparisonController - Content-Type:", response.headers.get('Content-Type'))
      
      if (response.ok) {
        const contentType = response.headers.get('Content-Type')
        if (contentType && contentType.includes('text/javascript')) {
          console.log("🟢 AiComparisonController - Executing JavaScript...")
          const jsCode = await response.text()
          eval(jsCode)
        } else {
          console.log("🟢 AiComparisonController - Unexpected content type:", contentType)
        }
      } else {
        console.error("🔴 AiComparisonController - Response error:", response.status, response.statusText)
      }
    } catch (error) {
      console.error("🔴 AiComparisonController - Error:", error)
    }
  }
} 